import locationBaseValidator from './location';

export default locationBaseValidator;
